<div class="container-fluid" [class.container-under-navbar]="isLoggedIn()">
    <ng-content></ng-content>
</div>
<fullscreen></fullscreen>
<simple-modal></simple-modal>
